export default defineNuxtRouteMiddleware((_to, _from) => {
  const config = useRuntimeConfig()
  const configHost = new URL(config.public.landingDomainName)
  if (process.client && window.location.hostname !== configHost.hostname) {
    if (_to.path === "/" || _to.path === "/pirmsskola" || _to.path === "/abonements") {
      _to.meta.layout = false
    } else {
      return navigateTo(config.public.landingDomainName + "/v2/", { external: true })
    }
  }
})
